import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ViewVision from './ViewVision.vue';

export default {
  path: '/admin',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'exPagantes', path: 'exPagantes', component: ViewVision },
  ],
};
